export default {
  SLS: "SLS",
  EDUPASS: "EDUPASS",
};
